var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { attrs: { title: "Procesamiento de documentos" } },
    [
      !_vm.loading
        ? _c(
            "form",
            {
              attrs: { autocomplete: "off", "data-vv-scope": "inputDoc" },
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                }
              }
            },
            [
              _c("hr", {}),
              _c("div", { staticClass: "row mb-3" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("h4", [_vm._v("Destinatario")]),
                    _vm.error.subject
                      ? _c("small", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.error.subject))
                        ])
                      : _vm._e(),
                    _c("SelectSubject", {
                      on: { "add-subject": _vm.addSubject }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("TableSubjects", { attrs: { subjects: _vm.subjects } }),
                    _c("small", { staticClass: "text-primary" }, [
                      _vm._v(
                        " Para cambiar el destinatario, solo ingrese uno nuevo y se reemplazará el actual "
                      )
                    ])
                  ],
                  1
                )
              ]),
              _c("hr", {}),
              _c("div", { staticClass: "row mb-3" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("h4", [_vm._v("Con copia a")]),
                    _c("SelectCopy", { on: { "add-copy": _vm.addCopy } })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("TableCopies", {
                      attrs: { copies: _vm.copies },
                      on: { removeCopy: _vm.removeCopy }
                    })
                  ],
                  1
                )
              ]),
              _c("hr", {}),
              typeof _vm.importedFile === "undefined"
                ? _c("div", { staticClass: "row mt-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 mt-2" },
                      [
                        _c("LoadFiles", {
                          attrs: { withTrueCopy: true },
                          on: {
                            mainFile: function($event) {
                              _vm.mainFile = $event
                            },
                            additionalFiles: function($event) {
                              _vm.additionalFiles = $event
                            }
                          },
                          model: {
                            value: _vm.inputFormat,
                            callback: function($$v) {
                              _vm.inputFormat = $$v
                            },
                            expression: "inputFormat"
                          }
                        }),
                        _vm.error.onlyPdf
                          ? _c("small", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.error.onlyPdf))
                            ])
                          : _vm._e(),
                        _vm.error.mainFile
                          ? _c("small", { staticClass: "text-danger pl-1" }, [
                              _vm._v(_vm._s(_vm.error.mainFile))
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _c("div", { staticClass: "row mt-5" }, [
                _c(
                  "div",
                  { staticClass: "col-12 mt-5 text-right" },
                  [
                    _c(
                      "vs-button",
                      {
                        staticClass: "mr-2 btn btn-success",
                        attrs: { disabled: _vm.loading },
                        on: { click: _vm.save }
                      },
                      [_vm._v(" Guardar ")]
                    ),
                    _vm.loading
                      ? _c("vs-progress", {
                          staticClass: "mb-1 mt-2",
                          attrs: { indeterminate: "", color: "primary" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e(),
      _c("Confirm", {
        attrs: {
          motherDocNumber: _vm.motherDocNumber,
          isMotherDocument: _vm.isMotherDocument,
          resetData: _vm.resetData,
          dntCode: _vm.dntCode,
          showConfirm: _vm.showConfirm,
          state: _vm.state,
          fromEditActioon: _vm.fromEditAction
        },
        on: { closeModal: _vm.closeConfirm }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }